module.exports = __webpack_public_path__ + "static/media/start-imaging-badge.93a05d6e.svg";